import { createSelector } from 'reselect'

import { PostingRootState } from '../postingRoot.reducer'

export const getInstagramFeeds = createSelector(
  (state: PostingRootState) => state.instagramStore.instagramFeeds,
  (state) => state,
)

export const getInstagramPage = createSelector(
  (state: PostingRootState) => state.instagramStore.instagramPage,
  (state) => state,
)
